import React from 'react'
import Header from '../../Header/Header'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../innerpage.css'
import { Row, Container, Col } from 'react-bootstrap'

import usabanner from '../../../images/usabanner.png'

const UsaBanner = () => {
  return (
    <>
      <div className='innerbanner pt-4 usabanner'>
        <Header></Header>
        <div className='container-fluid'>
          <Container>
            <Row className='d-flex justify-content-center align-items-center'>
              <Col md={5}>
                <img src={usabanner} alt="usabanner" className='animated2 infinite fadeInLeftRight'></img>
              </Col>
              <Col md={7}>
                <h2>Study in <span>USA</span></h2>
                <p>Change your country to be a changed version of yourself.  </p>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}

export default UsaBanner